import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";
import { generate_uid } from "@/utils";

interface PropTypes {
  section_id: string;
  open_initially?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CollapsibleSection',
  props: {
    section_id: null,
    open_initially: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { section_id: string, open_initially: boolean };



const is_open = ref(props.open_initially);
const component_uid = generate_uid();

function toggle_is_open() {
  is_open.value = !is_open.value;
}

return { __sfc: true,props, is_open, component_uid, toggle_is_open }
}

})